export default __webpack_public_path__ + "static/media/pin-code-display-img.58ee32e2.png";